import { OrderTypeEnum } from '@core/enums';
import { HomeProcessingRule } from '../interfaces';

export const homeDeliveryValidityRule: HomeProcessingRule = context => ({
	...context,
	hasValidDeliveryZone:
		context.orderType === OrderTypeEnum.Delivery &&
		!!context.store &&
		(context.deliveryZones ?? []).some(zone => zone.localId === context.store?.idLocal),
});

export const homeDeliveryModeRule: HomeProcessingRule = context => ({
	...context,
	isDeliveryMode: context.orderType === OrderTypeEnum.Delivery,
});

export const homeSwitchOrderTypeRule: HomeProcessingRule = context => ({
	...context,
	nextOrderType: context.isDeliveryMode ? OrderTypeEnum.Pickup : OrderTypeEnum.Delivery,
});

export const homeAddressByModeRule: HomeProcessingRule = context => ({
	...context,
	address: context.isDeliveryMode
		? (context.userLocation?.address ?? context.storeAddress ?? null)
		: (context.storeAddress ?? null),
});
